export function getFileInfos(ids, files) {
  const fileInfoMap = new Map((files || []).map((info) => [info.id, info]));
  return ids.filter(fileInfoMap.has.bind(fileInfoMap)).map(fileInfoMap.get.bind(fileInfoMap));
}
